<script setup lang="ts">
import { ref } from 'vue';
import { useFirestore } from 'vuefire';
import { query } from 'firebase/database';
import { collection, where, getDocs } from 'firebase/firestore';
import { DateTime } from 'luxon';
import { auth } from '@/firebase';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { PlayerCreds } from '@/secrets';
import { WordSet } from '@/models/WordSet';
import router from '@/router';


const gamePrepared = ref(false);
const errorPreparingPuzzle = ref(false);
const db = useFirestore();
const preparePuzzle = async () => {
  try {
    let rws = localStorage.getItem('wordSet');
    let ws = rws ? new WordSet(JSON.parse(rws)) : null;
    let puzzleDate = DateTime.utc().setZone('America/Denver').toFormat('yyyy-MM-dd');
    if (ws) {
        if (ws.date != puzzleDate) {
            ws = null;
        } else {
            gamePrepared.value = true;
        }
    }
    if (!ws) {
        //@ts-ignore
        const q = query(collection(db, 'wordSets'), where('isToday', '==', true));
        //@ts-ignore
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            const doc = querySnapshot.docs[0];  // Only one puzzle per day
            ws = new WordSet(doc.data());
            localStorage.setItem('wordSet', JSON.stringify(ws));
            gamePrepared.value = true;
        } else {
            console.error('No puzzle found for ' + puzzleDate);
            errorPreparingPuzzle.value = true;
        }
    }
  } catch (error) {
    console.error('Error preparing puzzle:', error);
    errorPreparingPuzzle.value = true;
  }
};

onAuthStateChanged(auth, (currentUser) => {
    if (!currentUser) {
        signInWithEmailAndPassword(auth, PlayerCreds.email, PlayerCreds.password)
            .catch(error => {
                console.error('Error signing in:', error);
                errorPreparingPuzzle.value = true;
            });
    } else {
        preparePuzzle();
    }
});

const getPuzzleNumber = () => {
  let now = DateTime.utc().setZone('America/Denver');
  return Math.floor(now.diff(DateTime.fromISO('2024-10-11'), 'days').days) + 1;
}
</script>

<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-10 offset-1 col-md-6 offset-md-3 h100">
                <div class="d-flex justify-content-center align-items-end h-50">
                    <div class="text-center">
                        <img src="@/assets/selections-logo.png" alt="" width="100px">
                        <h1 class="card-title mt-5" style="font-size: 3rem;">Selections</h1>
                        <h3 class="card-text">Pick the word with stronger connections</h3>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-start h-50">
                    <div class="text-center mt-5" style="font-size: 1.5rem;">
                        <div v-if="gamePrepared">
                            <div class="mb-2 btn btn-outline-light btn-lg" style="font-size: 1.5rem;" @click="router.push({ name: 'game' })">Play</div>
                            <div>Puzzle No. {{ getPuzzleNumber() }}</div>
                        </div>
                        <div v-else-if="errorPreparingPuzzle">
                            <div class="alert alert-info">Oh no, something went wrong 🙀 <br><br> We're looking into it! <br> In the meantime, try refreshing soon.</div>
                        </div>
                        <div v-else>
                            <div class="spinner-border text-light m-4" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>